<app-link-entities
  key="linkEntities"
  [cols]="linkPermissionSetsCols"
  [searchConfig]="linkPermissionSetsSearchConfig"
  [header]="'Link permission sets' | translate"
>
  <ng-template kpdTemplate="tableExtra" let-column let-item="item" let-index="index">
    <div *ngIf="column.type === 'type'" class="tags">
      <span
        class="state-tag"
        [ngClass]="{ 'state-tag--disabled': item[column.field] !== 'assign' && item[column.field] !== 'both' }"
        translate
        >Assign</span
      >
      <span
        class="state-tag"
        [ngClass]="{ 'state-tag--disabled': item[column.field] !== 'use' && item[column.field] !== 'both' }"
        translate
        >Use</span
      >
    </div>
    <div *ngIf="column.type === 'isKpdSet'">
      <img
        *ngIf="item[column.field]"
        src="assets/logos/kpd-logo_36x16.svg"
        alt="KPD"
        class="kpd-logo--blue-sm"
        [attr.title]="'This is a predefined set by KPD' | translate"
      />
    </div>
  </ng-template>
</app-link-entities>
<kpd-confirm-dialog key="confirmRolePermissionSetDelete"></kpd-confirm-dialog>

<div class="detail__grid" *ngIf="isRoleAvailable()">
  <div class="detail__toolbar">
    <kpd-action-bar *kpdPermission="Permissions.RolePermissionSetUpdate">
      <kpd-action-create (action)="onAdd()"> </kpd-action-create>
      <kpd-action-delete (action)="onDelete()" [disable]="!selection || selection.length === 0"> </kpd-action-delete>
    </kpd-action-bar>
  </div>

  <div class="detail__alert">
    <ng-container *ngIf="saveErrors.length > 0">
      <kpd-alert type="error" *ngFor="let error of saveErrors" icon="warning-standard">
        {{ error }}
      </kpd-alert>
    </ng-container>
  </div>

  <div class="detail__main">
    <kpd-entity-not-assigned
      icon="unlock"
      [header]="'No permissionsets assigned' | translate"
      [description]="'Assign a permisisonset by pressing the + button' | translate"
      *ngIf="!permissionSetsTree || permissionSetsTree.length === 0"
    ></kpd-entity-not-assigned>

    <div class="permissionsets-tree" *ngIf="!!permissionSetsTree && permissionSetsTree.length > 0">
      <div class="permissionsets-tree__title">
        <h3 translate>Permission sets</h3>
        <h3 translate>Type</h3>
      </div>

      <div *ngIf="!!permissionSetsTree && permissionSetsTree.length > 0">
        <p-tree
          [value]="permissionSetsTree"
          selectionMode="multiple"
          [(selection)]="selection"
          (onNodeExpand)="onNodeExpand($event)"
        >
          <ng-template let-node pTemplate="notFound">
            <clr-icon shape="info" class="permissionsets-tree__icon"></clr-icon>
            <span>{{ node.label }}</span>
          </ng-template>
          <ng-template let-node pTemplate="default">
            <div>
              <div class="branch" *ngIf="!node.leaf">
                <span>{{ node.label }}</span>
                <div>
                  <span *ngIf="node.data && node.data.type && node.data.isKpdSet"
                    ><img
                      src="assets/logos/kpd-logo_36x16.svg"
                      alt="KPD"
                      [attr.title]="'This is a predefined set by KPD' | translate"
                      class="kpd-logo--blue-sm"
                  /></span>
                </div>
                <div>
                  <span
                    class="state-tag"
                    [ngClass]="{ 'state-tag--disabled': node.data.type !== 'assign' && node.data.type !== 'both' }"
                    translate
                    >Assign</span
                  >
                  <span
                    class="state-tag"
                    [ngClass]="{ 'state-tag--disabled': node.data.type !== 'use' && node.data.type !== 'both' }"
                    translate
                    >Use</span
                  >
                </div>
              </div>
              <div class="permissionsets-tree__permission leaf flex-row" *ngIf="node.leaf">
                <span>{{ node.label }}</span>
                <kpd-info
                  *ngIf="node.label.length > 85"
                  [text]="node.label"
                  tooltipStyleClass="permissionsets-tree__permission--tooltip"
                ></kpd-info>
                <span
                  class="state-tag state-tag--deprecated"
                  [attr.title]="node.data.deprecatedMessage"
                  *ngIf="node.data && node.data.isDeprecated"
                  translate
                  >Deprecated</span
                >
              </div>
            </div>
          </ng-template>
        </p-tree>
      </div>
    </div>
  </div>
</div>
